// extracted by mini-css-extract-plugin
export default {"container":"AppointmentFooter_container__gK-bO"};